module.exports = __webpack_public_path__ + "static/media/moneyblack.b56627de.svg";